import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore as _createStore } from 'redux';

import ApiMiddleware from '../middleware/ApiMiddleware';
import { LoginMiddleware, LogOutMiddleware } from '../middleware/AuthMiddleware';
import { reducers as combinedReducers } from '../reducers';

export const history = createBrowserHistory();

const reduxRouterMiddleware = routerMiddleware(history);
const middleware = [reduxRouterMiddleware, LoginMiddleware, LogOutMiddleware, ApiMiddleware];

// Enable Redux DevTools Extension in all environments (including production) if available
const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = _createStore(combinedReducers(history), composeEnhancers(applyMiddleware(...middleware)));

export default store;
